import Imdb from './imdb'

import $ from 'jquery';
window.$ = $;
require("jquery")
require("@nathanvda/cocoon")
import 'select2';                       // globally assign select2 fn to $ element
import 'select2/dist/css/select2.css';  // optional if you have css loader
import Media from './media';
import Nav from './nav';

import UploadApp from './upload_app';
import UploadStatus from './upload_status';
import UploadBanner from './upload_banner';
import {Post, Dispatch} from './utils';

import Alpine from 'alpinejs';
Alpine.data('UploadStatus', UploadStatus)
Alpine.data('UploadBanner', UploadBanner)

function hook_imdb_app(opts) {
    setTimeout(function(){
        Media();
        Alpine.store('media').update();
        //Dispatch('validate-uploads');

        $('form').submit((evt)=> evt.preventDefault());

        //Dispatch('validate-uploads');
        let loader = $('.app-container-loader');
        if (loader && loader[0]) {
            loader.removeClass('opacity-100');
            loader.addClass('hidden');
        }

        $('.app-container').addClass('opacity-100');
    });

    return true;
}

window.hook_imdb_app = hook_imdb_app
$(document).ready(function(){
    Media();
    Alpine.store('media').update();
    Alpine.data('imdbapp', UploadApp);
    Alpine.start();
    hook_imdb_app();
});
//document.addEventListener("turbolinks:load", hook_imdb_app);

window.rails_ujs = require("@rails/ujs")
rails_ujs.start()

window.rails_active_storage = require("@rails/activestorage");
rails_active_storage.start();

window.rails_channels = require("channels")
// require("trix")
// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
